/**
 * Lands cross-page anchor links such as /#faq-section on their section. The browser's own jump runs
 * before late layout settles, and on desktop Horizon scrolls `.page-wrapper` instead of the document,
 * so the jump is repeated once the page has loaded. The target's scroll-margin keeps it clear of the
 * sticky header.
 */
function scrollToHash() {
  const id = decodeURIComponent(location.hash.slice(1));
  if (!id) return;
  const target = document.getElementById(id);
  if (!target) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
}

if (document.readyState === 'complete') {
  scrollToHash();
} else {
  window.addEventListener('load', () => requestAnimationFrame(scrollToHash), { once: true });
}
